import React, { Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { CSpinner, useColorModes } from '@coreui/react'
import './scss/style.scss'

// We use those styles to show code examples, you should remove them in your application.
import './scss/examples.scss'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Verification = React.lazy(() => import('./views/pages/verification/Verification'))
const VerificationMagicLogin = React.lazy(() => import('./views/pages/verification/VerificationMagicLogin'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const ResetPasswordLink = React.lazy(() => import('./views/pages/login/ResetPasswordLink'))
const ResetPasswordAction = React.lazy(() => import('./views/pages/login/ResetPasswordAction'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
 // const { isColorModeSet, setColorMode } = useColorModes('coreui-free-react-admin-template-theme')
  const { isColorModeSet, setColorMode } = useColorModes('ibg-theme')
  const storedTheme = useSelector((state) => state.MyApp.theme)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0]
    if (theme) {
      setColorMode(theme)
    }

    if (isColorModeSet()) {
      return
    }

    setColorMode(storedTheme)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <HashRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route exact path="/verification" name="Verification Page" element={<Verification />} />
          <Route exact path="/verification_magiclogin" name="Verification Page" element={<VerificationMagicLogin />} />
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/resetpasswordlink" name="Reset Password Link Page" element={<ResetPasswordLink/>} />
          <Route exact path="/resetpasswordaction" name="Reset Password Action Page" element={<ResetPasswordAction/>} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
